import type { PersistConfig } from '@ms/yammer-data/dist/persistedState';
import { getPersistConfig } from '@ms/yammer-data/dist/persistedState';

import type { YammerTeamsNativeState } from '../state/types';

export const persistAppNameKey = 'teams-branded-exp';

export const persistConfig: PersistConfig<YammerTeamsNativeState> = getPersistConfig<YammerTeamsNativeState>({
  key: persistAppNameKey,
  allowlist: ['ecsConfig', 'ecsExperiments', 'ecsFeatureRollouts'],
});
